import { createFileRoute, Link, useNavigate } from '@tanstack/react-router';
import { Anchor, Button, Stack, Text, TextInput, Title } from '@mantine/core';
import { useForm, schemaResolver } from '@mantine/form';
import { z } from 'zod';
import { notifications } from '@mantine/notifications';
import { useState } from 'react';
import * as authApi from '@/features/auth/api';
import { userFacingMessage } from '@/shared/api/errorMessage';

const schema = z.object({ email: z.string().email('Email non valida') });

export const Route = createFileRoute('/_auth/recovery-password')({ component: RecoveryPage });

function RecoveryPage() {
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const form = useForm({
    mode: 'controlled',
    initialValues: { email: '' },
    validate: schemaResolver(schema, { sync: true }),
  });

  const onSubmit = form.onSubmit(async ({ email }) => {
    setBusy(true);
    try {
      await authApi.requestPasswordReset(email);
      notifications.show({ color: 'green', message: 'Email di recupero inviata, controlla la posta.' });
      void navigate({ to: '/update-password', search: { email } });
    } catch (err) {
      const msg = userFacingMessage(err, 'Errore');
      notifications.show({ color: 'red', title: 'Recupero fallito', message: msg });
    } finally {
      setBusy(false);
    }
  });

  return (
    <Stack>
      <div>
        <Title order={2}>Recupera password</Title>
        <Text c="dimmed" size="sm">
          Ti invieremo un codice via email.
        </Text>
      </div>
      <form onSubmit={onSubmit}>
        <Stack>
          <TextInput label="Email" required type="email" {...form.getInputProps('email')} />
          <Button type="submit" loading={busy} fullWidth size="md">Invia codice</Button>
          <Text size="sm" ta="center">
            <Anchor component={Link} to="/login">Torna al login</Anchor>
          </Text>
        </Stack>
      </form>
    </Stack>
  );
}
